import React, { Component } from 'react';
import { apisettigs } from '../../../src/settings.js';
import { ModalConfirm, ModalConfirmReject, ModalWtng, ModalHasUnreadMsg } from '../../../src/components/solicitacao/modals.js';
import { Modal } from 'bootstrap';

class Ordem extends Component{

    constructor(props) {        
        super(props);
        this.state = {
            show: false,
            selectedId: '',  
            isBkp:'',
            oriApprv:'',          
            orders: [],
        };

    }


    showOrdem = () => {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json charset=utf-8', },
            body: JSON.stringify({ userid: window.sessionStorage.getItem("userId") })
        };

        fetch(apisettigs.endpoints.orders, requestOptions).then(response => response.json())
        .then(data => {
            this.setState({orders: data});
            //console.log(data);
            this.setState({show: true});
        });

    }
    

    hideOrdem = () => {
        this.setState({show: false});
    }


    showModalConfirm = (reqid, bkp, origAppr) => {
        if(bkp === 'B'){
            this.setState({isBkp: 'Y'});
            this.setState({oriApprv: origAppr});
        }
        else{
            this.setState({isBkp:''});
            this.setState({oriApprv: ''});
        }
        this.setState({selectedId: reqid});
        var myModal = new Modal(document.getElementById('ModalConfirm'));
        document.getElementById('nputComment').value = '';
        myModal.show();
       
    }


    showModalConfirmReject = (reqid,bkp, origAppr) => {
        if(bkp === 'B'){
            this.setState({isBkp:'Y'});  
            this.setState({oriApprv: origAppr});     
        }
        else{
            this.setState({isBkp:''});
            this.setState({oriApprv: ''});
        }
        this.setState({selectedId: reqid});
        var rejModal = new Modal(document.getElementById('ModalConfirmReject'));
        document.getElementById('nputCommentRej').value = '';
        rejModal.show();
    }


    rejectOne = () => {
       
        let buttonEl = document.getElementById('mdlBtnRej');

        if(buttonEl.getAttribute('clicked') === 'no'){
            buttonEl.setAttribute('clicked', 'yes'); 

            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json charset=utf-8', },
                body: JSON.stringify({ 
                    userid: window.sessionStorage.getItem("userId"),
                    reqid: this.state.selectedId,
                    userComment: document.getElementById('nputCommentRej').value.trim(),
                    isBackup: this.state.isBkp,
                    origApprov: this.state.oriApprv,
                })
            };

            let modalReject = Modal.getInstance(document.getElementById('ModalConfirmReject'));
            modalReject.hide();

            let modalWntEl = document.getElementById('ModalWtng');
            let modalW = new Modal(modalWntEl);

            modalWntEl.addEventListener('shown.bs.modal',() =>{
                
                fetch(apisettigs.endpoints.rejectOrder, requestOptions).then(response => response.json())
                .then(data => {
                    buttonEl.setAttribute('clicked', 'no');
                    //console.log(data);

                    let modalHasMsg = Modal.getOrCreateInstance(document.getElementById('ModalUnreadMsg'));

                    let modalW2 = Modal.getOrCreateInstance(modalWntEl);
                    modalW2.hide();

                    if(data.ApproveResult === 'unreadMsg'){
                        modalHasMsg.show();
                    }

                    //reload the view
                    this.hideOrdem();
                    this.showOrdem();
                })  

            });
            
            modalW.show();
        
        }
        
    }


    approveOne = () => {

        let buttonEl = document.getElementById('mdlBtnApprv');
        
        if(buttonEl.getAttribute('clicked') === 'no'){

            buttonEl.setAttribute('clicked', 'yes');

            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json charset=utf-8', },
                body: JSON.stringify({ 
                    userid: window.sessionStorage.getItem("userId"),
                    reqid: this.state.selectedId,
                    userComment: document.getElementById('nputComment').value.trim(),
                    isBackup: this.state.isBkp,
                    origApprov: this.state.oriApprv,
                })
            };
                    

            let modalApprove = Modal.getInstance(document.getElementById('ModalConfirm'));
            modalApprove.hide();
            
            let modalWntEl = document.getElementById('ModalWtng');
            let modalW = new Modal(modalWntEl);
              
            modalWntEl.addEventListener('shown.bs.modal',() =>{
                
                fetch(apisettigs.endpoints.approveOrder, requestOptions).then(response => response.json())
                .then(data => {
                    buttonEl.setAttribute('clicked', 'no');
                    //console.log(data);
                   
                    let modalHasMsg = Modal.getOrCreateInstance(document.getElementById('ModalUnreadMsg'));

                    let modalW2 = Modal.getOrCreateInstance(modalWntEl);
                    modalW2.hide();
                    
                    if(data.ApproveResult === 'unreadMsg'){
                        modalHasMsg.show();
                    }
                    
                    //reload the view
                    this.hideOrdem();
                    this.showOrdem();
                })  

            });
            
            modalW.show();

        }

        
    }


    approveAll = (event) => {
        let buttonEl = event.target;
        
        const selectedReqs = document.getElementsByClassName("requestSelect");

        let selectedRequestIds = [];

        for (var checkbox of selectedReqs){
            if (checkbox.checked){
                selectedRequestIds.push({'reqid': checkbox.getAttribute('reqid'),
                'msgcnt': checkbox.getAttribute('msgcnt'),
                'bkp': checkbox.getAttribute('bkp'),
                'origapprove': checkbox.getAttribute('origapprove'),
                });
            }
        }

        if (selectedRequestIds.length >= 1){
            buttonEl.disabled = true;
            
            let modalWntEl3 = document.getElementById('ModalWtng');            
            let modalW3 = new Modal(modalWntEl3);

            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json charset=utf-8', },
                body: JSON.stringify({ 
                    userid: window.sessionStorage.getItem("userId"),
                    reqlist: selectedRequestIds,
                })
            };

            modalWntEl3.addEventListener('shown.bs.modal',() => {
                
                fetch(apisettigs.endpoints.approveAllOrders, requestOptions).then(response => response.json())
                .then(data => {
                    buttonEl.setAttribute('clicked', 'no');
                    //console.log(data);
                   
                    let modalHasMsg = Modal.getOrCreateInstance(document.getElementById('ModalUnreadMsg'));

                    let modalW23 = Modal.getOrCreateInstance(modalWntEl3);
                    modalW23.hide();
                    
                    if(data.ApproveResult === 'unreadMsg'){
                        modalHasMsg.show();
                    }

                    //reload the view
                    this.hideOrdem();
                    this.showOrdem();
                })  

            });
            
            modalW3.show();
            //console.log(selectedRequestIds);
        }

    }


    ocultarEnv(count){
        if(count <= 0){
            return 'd-none'
        }
    }


    showMensagens = (reqType, reqid) =>{
        this.props.showMensagens(reqType, reqid , 'N');
    }


    showListarItens = (reqType, reqid) =>{
        this.props.showListarItens(reqType, reqid);
    }


    showCotacoes = (reqid) => {
        this.props.showCotacoes(reqid);
    }


    showListarSolics = (reqid) => {
       this.props.showListarSolics(reqid); 
    }


    render(){
        if (this.state.show === true){
            return (
                <>
                    {this.state.orders.map( orders => {
                        return(
                            <div className='container mt-4'>

                                    <div className='row justify-content-center'>
                                        <div className='colTitle col- align-self-center ' style={{width:'6rem', padding:'0 0 0 0.2rem'}}> 
                                            Dt.Lançamento
                                        </div>
                                        <div className='colText col- align-self-center ' style={{ maxWidth:'59%'}}>
                                            {orders.creadate}
                                        </div>
                                        <div className='colText col- ' style={{width:'1.8rem', padding:'0'}}>
                                            <img className={orders.hasMsg} src= {apisettigs.serverUrl + 'static/images/msgsm.png'} alt="" />
                                        </div>
                                    </div>

                                    <div className='row justify-content-center'>
                                        <div className='colTitle col-  align-self-center ' style={{width:'6rem', padding:'0 0 0 0.2rem'}}>
                                            Dt.Entrega
                                        </div>
                                        <div className='colText col- align-self-center ' style={{maxWidth:'59%'}}>
                                            {orders.reqdate}
                                        </div>
                                        <div className='colText col- align-self-center ' style={{width:'1.8rem', padding:'0.5rem 0 0 0'}}>
                                            <div className={'position-relative ' + this.ocultarEnv(orders.msgCnt) } >
                                                <img src= {apisettigs.serverUrl + 'static/images/mail-icon-post.png'} alt="" height="auto" width="25px"/>
                                                <div className="badgeM badgeM-pad2">{orders.msgCnt}</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row justify-content-center'>
                                        <div className='colTitle col- align-self-center ' style={{width:'6rem', padding:'0 0 0 0.2rem'}}>
                                            Solicitante
                                        </div>
                                        <div className='colText col- align-self-center ' style={{maxWidth:'59%'}}>
                                            {orders.solic}
                                        </div>
                                        <div className='colText col- ' style={{width:'1.8rem', padding:'0'}}></div>
                                    </div>

                                    <div className='row justify-content-center'>
                                        <div className='colTitle col-  align-self-center' style={{width:'6rem', padding:'0 0 0 0.2rem'}}>
                                            Dpto.Solicitante
                                        </div>
                                        <div className='colText col-  align-self-center ' style={{maxWidth:'59%', paddingBottom:'.1rem'}}>
                                            {orders.ccnum} - {orders.ccname}
                                        </div>
                                        <div className='colText col- align-self-center ' style={{width:'1.8rem', padding:'0'}}>
                                            <input className='form-check-input requestSelect' type="checkbox" style={{fontSize:'1.5rem'}} reqid={orders.id} msgcnt={orders.msgCnt} bkp={orders.bkp} origapprove={orders.origiApprov} />
                                        </div>
                                    </div>

                                    <div className='row justify-content-center'>
                                        <div className='colTitle col- align-self-center ' style={{width:'6rem', padding:'0 0 0 0.2rem'}}>
                                            Observação
                                        </div>
                                        <div className='colText col- align-self-center ' style={{maxWidth:'59%'}}>
                                            {orders.comments}
                                        </div>
                                        <div className='colText col- align-self-center text-center' style={{width:'1.8rem', padding:'1rem 0 0 0'}}>
                                            <div style={{color:'red',fontSize:'1rem'}}>
                                                {orders.bkp}
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row justify-content-center'>
                                        <div className='colTitle col-  align-self-center'  style={{width:'6rem', padding:'0 0 0 0.2rem'}}>
                                            Valor
                                        </div>
                                        <div className='colText col-  align-self-center' style={{maxWidth:'59%'}}>
                                            {orders.value}
                                        </div>
                                        <div className='colText col- ' style={{width:'1.8rem', padding:'0'}}></div>
                                    </div>

                                    <div className='row justify-content-center'>
                                        <div className='colTitle col-  align-self-center'  style={{width:'6rem', padding:'0 0 0 0.2rem'}}>
                                            Ult.Aprovador
                                        </div>
                                        <div className='colText col-  align-self-center' style={{maxWidth:'59%'}}>
                                            {orders.lastApprov}
                                        </div>
                                        <div className='colText col- ' style={{width:'1.8rem', padding:'0'}}></div>
                                    </div>

                                    <div className='container mt-3' style={{padding:'0'}}>
                                        <div className='d-flex  justify-content-center' style={{width:'100%'}} > 
                                            <div className='btnLightBlue' onClick={()=> this.showListarSolics(orders.id)}> <i className="fas fa-clipboard-check" ></i></div> 
                                            <div className='btnBlue' onClick={()=> this.showCotacoes(orders.id)}> <i className="fas fa-clipboard" ></i></div> 
                                            <div className='btnGrey' onClick={()=> this.showListarItens('Ordem', orders.id)}><i className="fas fa-bars"></i></div>
                                            <div className='btnYellow' onClick={() => this.showMensagens('Ordem', orders.id)}><i className="fas fa-envelope-open-text"></i></div>
                                            <div className='btnRed' onClick={() => this.showModalConfirmReject(orders.id, orders.bkp, orders.origiApprov)}><i className="fas fa-times"></i></div>
                                            <div className='btnGreen' onClick={() => this.showModalConfirm(orders.id, orders.bkp, orders.origiApprov)}><i className="fas fa-check"></i></div>
                                        </div>
                                    </div>
                    
                                    <hr className='hLn'/>

                                </div>
                        );
                    })}

                    <div className='container text-center mt-4 mb-4'>
                        <button type="button" className="btn btn-primary" onClick={this.approveAll}>Aprovar Selecionados</button>
                    </div>

                    <ModalConfirm approve={this.approveOne}/>
                    <ModalConfirmReject reject={this.rejectOne}/>
                    <ModalWtng />
                    <ModalHasUnreadMsg />
                </>
            );
        }
        else{
            return null;
        }
    }
}

export default Ordem